<div class="inner-header-notifications" (click)="show();">
    <div>
        <i class="fal fa-fw fa-2x fa-bell" [ngClass]="notfCounter !== 0 ? 'wabble' : ''" aria-hidden="true"></i>
    </div>
    <span class="badge">{{notfCounter == 0 ? '' : notfCounter}}</span>
</div>
